import { useMutation } from '@tanstack/react-query';

import { CabinEventClient, FlightEventFlightDetailsLookup } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const cabinEventClient = new CabinEventClient(apiBaseUrl);

function useCreateNewCabinEvent() {
  return useMutation({
    mutationKey: [queryKeys.CabinEvent.CreateNew],
    mutationFn: (lookup: FlightEventFlightDetailsLookup) => cabinEventClient.createNew(lookup),
  });
}

export default useCreateNewCabinEvent;
